
import {defineComponent, ref, Ref} from "vue";
import { mapActions } from "vuex";

export default defineComponent({
    name: "FilterCheck",
    props: {
        data: {
            type: Object,
            required: true
        },
        hidden: {
            type: Boolean,
            default: false
        }
    },
    methods: mapActions({
        handleChange: 'CHANGE_PARAMETER'
    })
})
